"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faTimes_1 = require("@fortawesome/free-solid-svg-icons/faTimes");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const alert_1 = __importDefault(require("@reach/alert"));
require("@reach/dialog/styles.css");
const react_1 = require("react");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
const Button_1 = require("../Button");
const Flex_1 = require("../Flex");
function Toaster({ toasts }) {
    return (jsx_runtime_1.jsx(StyledToasterBox, Object.assign({ position: "fixed", bottom: 0, right: 0, zIndex: 100, maxWidth: "100%", padding: "1rem" }, { children: toasts.map(toast => (jsx_runtime_1.jsx(Toast, Object.assign({}, toast), toast.id))) }), void 0));
}
exports.Toaster = Toaster;
function Toast({ message, dismiss, delay }) {
    const [visible, setVisible] = react_1.useState(true);
    const visibleTimeout = react_1.useRef(null);
    const fadeAwayTimeout = react_1.useRef(null);
    const [hovering, setHovering] = react_1.useState(false);
    react_1.useEffect(() => {
        if (!visibleTimeout.current && !hovering) {
            visibleTimeout.current = setTimeout(() => {
                setVisible(false);
            }, delay);
        }
    });
    react_1.useEffect(() => {
        if (!fadeAwayTimeout.current && !visible && !hovering) {
            fadeAwayTimeout.current = setTimeout(() => {
                dismiss();
            }, 2000);
        }
    });
    const clearTimeouts = () => {
        if (visibleTimeout.current !== null) {
            clearTimeout(visibleTimeout.current);
            visibleTimeout.current = null;
        }
        if (fadeAwayTimeout.current !== null) {
            clearTimeout(fadeAwayTimeout.current);
            fadeAwayTimeout.current = null;
        }
    };
    react_1.useEffect(() => {
        if (hovering) {
            clearTimeouts();
        }
    });
    const onPointerEnter = () => {
        setHovering(true);
        setVisible(true);
    };
    const onPointerLeave = () => {
        setHovering(false);
        setVisible(true);
    };
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: alert_1.default, backgroundColor: "danger", color: "#fff", width: "30rem", maxWidth: "100%", padding: "1rem", opacity: visible ? 1 : 0, mt: "1rem", onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, position: "relative", transition: visible ? 'all 0.1s' : 'all 2s', transform: `scale(1, ${visible ? 1 : 0.9})`, style: { pointerEvents: 'all' } }, { children: jsx_runtime_1.jsxs(Flex_1.Flex, Object.assign({ alignItems: "center" }, { children: [jsx_runtime_1.jsx(Box_1.Box, Object.assign({ flex: 1 }, { children: message }), void 0),
                jsx_runtime_1.jsx(Button_1.Button, Object.assign({ onClick: () => dismiss(), backgroundColor: "transparent", color: "#fff", p: 0, py: 0 }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: faTimes_1.faTimes }, void 0) }), void 0)] }), void 0) }), void 0));
}
const StyledToasterBox = tools_1.styled(Box_1.Box) `
  pointer-events: none;
`;
//# sourceMappingURL=index.js.map